<template>
<div class="[ c-island c-island--large@lg ]  t-background-white-grey t-margin-bottom-s">
    <h2 class="t-text-style-beta">Kompetens</h2>
	<table class="c-list-component  t-margin-top-s">
		<template v-for="row of rows" >
			<template v-if="inEditMode.includes(row.id)">
				<competence-card-competence-data-provider 
					:competence-card-id="competenceCardId" 
					:competence-id="row.id" v-bind:key="row">
						<tr slot-scope="dataProvider">
							<td colspan="4">
								<competence-card-competence 
									mode="edit"
									v-bind="dataProvider.competence"
									:competence-card-id="competenceCardId"
									:competenceOptions="dataProvider.competenceOptions"
									:competenceLevelOptions="dataProvider.competenceLevelOptions"
									@cancelEditCompetence="goToViewMode"
									@editCompetence="dataProvider.editCompetence"
									@deleteCompetence="dataProvider.deleteCompetence">
								</competence-card-competence>
							</td>
						</tr>
				</competence-card-competence-data-provider>
			</template>
			<list-row v-else :row="row" v-bind:key="row">
				<template slot="last-item">	
					<td class="c-list-item list-item-icon-competence">
						<span class="c-list-item__label">Visas på kompetenskort</span>
						<p class="t-text-style-epsilon">
						<span class="c-icon-link checkboxborder"><span aria-hidden="true" :class="`c-icon  c-icon--link c-icon-link_icon ${row.printOptionClass}`"><svg><use xlink:href="#icon-checkbox"></use></svg></span><span></span></span>
						</p>		
					</td>			
					<td class="c-list-item t-text-align-right">				
						<button v-if="$can('manage', 'CompetenceCard')" type="button" class="c-button c-button--linkstyle c-button--reset" @click="goToEditMode(row.id)">Ändra</button>
					</td>
				</template>
			</list-row>		
		</template>
	</table>
	<button v-if="$can('manage', 'CompetenceCard') && !showCreate" class="c-button c-button--primary t-margin-top-m" type="button" @click="toggleCreate">Lägg till kompetens</button>
	<competence-card-competence-data-provider v-if="showCreate">
		<template slot-scope="dataProvider">
			<competence-card-competence 
				mode="create"
				:competence-card-id="competenceCardId"
				:competenceOptions="dataProvider.competenceOptions"
				:competenceLevelOptions="dataProvider.competenceLevelOptions"
				@createCompetence="dataProvider.createCompetence"
				@cancelCreateCompetence="toggleCreate">
			</competence-card-competence>
		</template>
	</competence-card-competence-data-provider>
</div>
</template>

<script>
import VueInput from '@/components/vue-components/vue-input/VueInput.vue';
import ListComponent from '@/components/vue-components/list-component/ListComponent.vue';
import ListRow from '@/components/vue-components/list-row/ListRow.vue';
import CompetenceCardCompetenceDataProvider from '@/components/competences/competence-card-competence-data-provider/CompetenceCardCompetenceDataProvider.vue';
import CompetenceCardCompetence from '@/components/competences/competence-card-competence/CompetenceCardCompetence.vue';
export default {
    name: 'CompetenceCardCompetences',
    components: {
        VueInput,
        ListComponent,
		ListRow,
		CompetenceCardCompetenceDataProvider,
		CompetenceCardCompetence,
    },
    props: {
        competenceCardId: {
            type: String,
            default: '0'
        },
		rows: {
			type: Array,
			default: () => []
		}
    },
	data: () => ({
        inEditMode: [],
		showCreate: false,
    }),
    methods: {
        setSubmitType(type) {
            this.submitType = type;
        },
        handleSubmit() {
            switch (this.submitType) {
                case 'create':
                    this.create();
                    break;
            }
        },
        goToEditMode(id) {
            if (!this.inEditMode.includes(id)) this.inEditMode.push(id);
        },
		goToViewMode(id) {
			this.inEditMode = this.inEditMode.filter(i => i !== id);
		},
		toggleCreate() {
			this.showCreate = !this.showCreate;
		}
    },
}
</script>
